import { Resource } from './resource';

export class Priority extends Resource {
    name: string;
    value : string;
    label : string;
    sourceName:string;
  }